import { useTheme } from "@emotion/react";
import { CardMembership, Check } from "@mui/icons-material";
import { Avatar, Box, Card, CardContent, Chip, FormControl, FormControlLabel, Grid, List, ListItem, ListItemIcon, ListItemText, Paper, Radio, RadioGroup, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useCallback, useEffect, useState } from "react";
import { getVendorPasses } from "services/vendorDashboard";


export default function VendorPasses({vendorId}) {
  
  const { enqueueSnackbar } = useSnackbar();
  const [passes, setPasses] = useState(null);
  const theme = useTheme();

  const getPasses = useCallback((vendorId) => {
    getVendorPasses({}, {}, {vendorId}).then(({response, error}) => {
      if(response){
        setPasses(response);
      } else {
        setPasses([]);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }, [enqueueSnackbar]);
  
  useEffect(() => {
    if(vendorId){
      getPasses(vendorId);
    }
  }, [getPasses, vendorId]);
  
  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }} elevation={0}>
     
      <Box noValidate>
        <Grid container columnSpacing={4} rowSpacing={2} >
        {(passes || []).map((pass, index) => (
            <Grid item xs={10} sm={6} md={6} xl={3} lg={4} key={index} >
              <Card sx={{ p: 1.5, pb: '3rem', position: 'relative', height: '100%', border: `1px solid${theme.palette.primary.light}`}}>
                <CardContent>
                  <Typography gutterBottom variant="body1" component="div" textAlign="center" sx={{ p: 0, m:0, lineHeight: 1, }}>
                    {pass.title}
                    <Typography gutterBottom variant="caption" component="div" textAlign="center" sx={{ p: 1, lineHeight: 1, }}>
                      {pass.property.name}
                    </Typography>
                    <Avatar sx={{ width: 56, height: 56, margin: '1em  auto .7em',  bgcolor: theme.palette.primary.dark}}>
                      <CardMembership />
                    </Avatar>
                  </Typography>
                 
                  
                  <Typography gutterBottom variant="subtitle2" component="div" textAlign="center">
                    Rs. {pass.price} /-
                  </Typography>

                  <Box>
                    <List dense={true}>
                      {Array.isArray(pass?.features) ? 
                      pass?.features.map((feature, index) => (
                        <ListItem key={index} sx={{ p: 0,}}>
                          <ListItemIcon>
                            <Check />
                          </ListItemIcon>
                          <ListItemText primary={feature} />
                        </ListItem>
                      )) : null}
                    </List>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
          {passes?.length === 0 ? (
            <Typography color="error" variant="h5" component="h5"> No data found</Typography>
          ): null}
        </Grid>
      </Box>
    </Paper>
  );
}
